<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import flashMessage from "../../components/flashMessahe";
import { ModelSelect } from 'vue-search-select';
import ErrorMessage from "../../components/error-message";
import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from "vuelidate/lib/validators";

export default {
  components: {
      ErrorMessage,
    Layout,
    PageHeader,
    flashMessage,
      ModelSelect
  },
  data() {
    return {
      errorMessage: "",
      title: "Admin Create",
      items: [
        {
          text: "Admin Setting",
          href: "/",
        },
        {
          text: "Create",
          active: true,
        },
      ],
      status: "not_accepted",
      checkCustom: "not_accepted",
      checked: true,
      errors: null,
        visible:false,
        message:"",
        country_list:[],
      form: {
        first_name: "",
        last_name: "",
        gender: "",
        email: "",
        country_code: "",
        country: "",
        phone_code: "",
        phone_number: "",
        password: "",
        password_confirmation: "",
      },
      submitform: false,
      submitted: false,
    };
  },
  validations: {
    form: {
      first_name: {
        required,
      },
      last_name: {
        required,
      },
      gender: {
        required,
      },
      email: {
        required,
      },
      country_code: {
        required,
      },
      country: {
        required,
      },
      phone_code: {
        required,
      },
      phone_number: {
        required,
      },
      password: {
        required,
      },
      password_confirmation: {
        required,
      },
    },
  },
    mounted() {
        this.getCountryList();
    },
  methods: {
      setCountryAndPhoneCode(event){
          let countries=this.country_list;
          let i;
          for(i=0;i<countries.length;i++){
              if(countries[i].countryName==event){
                  this.form.country_code=countries[i].countryCode;
                  this.form.phone_code=countries[i].phoneCode;
              }
          }
      },
      setPhoneCodeWiseCountry(event){
          let countries=this.country_list;
          let i;
          for(i=0;i<countries.length;i++){
              if(countries[i].phoneCode==event.target.value){
                  this.form.country_code=countries[i].countryCode;
                  this.form.phone_code=countries[i].phoneCode;
                  this.form.country=countries[i].countryName;
              }
          }
      },
      async getCountryList() {
          try {
              axios
                  .get("/api/country/list", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                      },
                  })
                  .then((response) => {
                      if (response.status) {
                          var temp=response.data.data;

                          var i;
                          for (i=0;i<temp.length;i++){
                              temp[i].value=temp[i].countryName;
                              temp[i].text=temp[i].countryName+' ('+temp[i].countryCode+')';
                          }
                          this.country_list = temp;
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
      onClose(){
          this.visible=false;
      },
    formSubmit(event) {
      this.submitted = true;
      this.$v.$touch();
      axios
        .post("/api/admin/create", {
          first_name: this.form.first_name,
          last_name: this.form.last_name,
          gender: this.form.gender,
          email: this.form.email,
          country_code: this.form.country_code,
          country: this.form.country,
          phone_code: this.form.phone_code,
          phone_number: this.form.phone_number,
          password: this.form.password,
          password_confirmation: this.form.password_confirmation,
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then((response) => {
          if (response.data.status) {
            this.$refs.adminForm.reset();
            this.$swal("Good job!", "Admin Created", "success");
            this.$router.push({ name: "all_admin" });
          } else {
            var str = response.data.message;
            var jsonParse = JSON.parse(str);
            this.errorCheck(jsonParse);
          }
        })
        .catch((error) => {
          if (error.response != undefined) {
            this.errors = error.response.data.errors;
          }
        });
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
            this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    resetForm(event) {
      // console.log("Reseting the form");
      event.target.reset();
    },
  },
};
</script>

<template>
  <Layout>
    <flashMessage/>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div v-if="errors" class="font-bold mb-4 ">
              <div v-for="(v, k) in errors" :key="k">
                <p v-for="error in v" :key="error" class="text-sm">
                  {{ error }}
                </p>
              </div>
            </div>
            <b-form class="needs-validation" ref="adminForm" @submit.prevent="formSubmit">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="required" for="first_name">First Name</label>
                    <input
                      id="first_name"
                      v-model="form.first_name"
                      name="first_name"
                      type="text"
                      class="form-control"
                      placeholder="Type First Name"
                      value
                      :class="{ 'is-invalid': submitted && $v.form.first_name.$error }"
                    />
                    <div
                      v-if="submitted && $v.form.first_name.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.first_name.required">This value is required.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="required" for="last_name">Last Name</label>
                    <input
                      id="last_name"
                      v-model="form.last_name"
                      name="last_name"
                      type="text"
                      class="form-control"
                      placeholder="Type Last Name"
                      value
                      :class="{ 'is-invalid': submitted && $v.form.last_name.$error }"
                    />
                    <div
                      v-if="submitted && $v.form.last_name.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.last_name.required">This value is required.</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label class="required" for="gender">Gender</label>
                    <select
                      id="gender"
                      name="gender"
                      v-model="form.gender"
                      type="text"
                      class="form-control"
                      placeholder="Type Gender"
                      value
                      :class="{ 'is-invalid': submitted && $v.form.gender.$error }">
                        <option value="" disabled style="display:none" selected>Select Gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </select>
                    <div
                      v-if="submitted && $v.form.gender.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.gender.required">This value is required.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="required" for="email">Email</label>
                    <input
                      id="email"
                      v-model="form.email"
                      name="email"
                      type="email"
                      class="form-control"
                      placeholder="Type Email"
                      value
                      :class="{ 'is-invalid': submitted && $v.form.email.$error }"
                    />
                    <div
                      v-if="submitted && $v.form.email.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.email.required">This value is required.</span>
                    </div>
                  </div>
                </div>
<!--                <div class="col-md-6">-->
<!--                    <div class="form-group">-->
<!--                        <label class="required" for="country_code">Country Code</label>-->
<!--                        <select-->
<!--                            id="country_code"-->
<!--                            name="country_code"-->
<!--                            v-model="form.country_code"-->
<!--                            type="text"-->
<!--                            class="form-control"-->
<!--                            placeholder="Type permission type"-->
<!--                            value-->
<!--                            :class="{ 'is-invalid': submitted && $v.form.country_code.$error }">-->
<!--                            <option value="" disabled style="display:none" selected>Select Country Code</option>-->
<!--                            <option value="AUS">AUS</option>-->
<!--                            <option value="BD">BD</option>-->
<!--                            <option value="CA">CA</option>-->
<!--                            <option value="DEN">DEN</option>-->
<!--                            <option value="UK">UK</option>-->
<!--                            <option value="KSA">KSA</option>-->
<!--                        </select>-->
<!--                        <div-->
<!--                            v-if="submitted && $v.form.country_code.$error"-->
<!--                            class="invalid-feedback"-->
<!--                        >-->
<!--                            <span v-if="!$v.form.country_code.required">This value is required.</span>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="col-md-6">-->
<!--                    <div class="form-group">-->
<!--                        <label class="required" for="country">Country</label>-->
<!--                        <select-->
<!--                            id="country"-->
<!--                            name="country"-->
<!--                            v-model="form.country"-->
<!--                            type="text"-->
<!--                            class="form-control"-->
<!--                            placeholder="Type permission type"-->
<!--                            value-->
<!--                            :class="{ 'is-invalid': submitted && $v.form.country.$error }">-->
<!--                            <option value="" disabled style="display:none" selected>Select Country</option>-->
<!--                            <option value="Australia">Australia</option>-->
<!--                            <option value="Bangladesh">Bangladesh</option>-->
<!--                            <option value="Canada">Canada</option>-->
<!--                            <option value="Denmark">Denmark</option>-->
<!--                            <option value="United Kingdom">United Kingdom</option>-->
<!--                            <option value="Saudi Arabia">Saudi Arabia</option>-->
<!--                        </select>-->
<!--                        <div-->
<!--                            v-if="submitted && $v.form.country.$error"-->
<!--                            class="invalid-feedback"-->
<!--                        >-->
<!--                            <span v-if="!$v.form.country.required">This value is required.</span>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
                  <div class="col-md-6">
                      <div class="form-group">
                          <label class="required" for="country">Country</label>
<!--                          <select-->
<!--                              id="country"-->
<!--                              name="country"-->
<!--                              v-model="form.country"-->
<!--                              v-on:change="setCountryAndPhoneCode"-->
<!--                              type="text"-->
<!--                              class="form-control"-->
<!--                              placeholder="Select Country"-->
<!--                              value-->
<!--                              :class="{ 'is-invalid': submitted && $v.form.country.$error }">-->
<!--                              <option value="" disabled style="display:none" selected>Select Country</option>a-->
<!--                              <option v-for="(country, index) in country_list" :value="country.countryName"-->
<!--                                      v-bind:key="index">{{ country.countryName}}-->
<!--                              </option>-->
<!--                          </select>-->
                          <model-select :options="country_list"
                                        v-model="form.country"
                                        @input="setCountryAndPhoneCode($event)"
                                        :class="{ 'is-invalid': submitted && $v.form.country.$error }"
                                        placeholder="Select Country"
                                       >
                          </model-select>
                          <div
                              v-if="submitted && $v.form.country.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.country.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <div class="form-group">
                          <label class="required" for="phone_code">Phone Code</label>
                          <select
                              id="phone_code"
                              name="phone_code"
                              v-model="form.phone_code"
                              v-on:change="setPhoneCodeWiseCountry"
                              type="text"
                              class="form-control"
                              placeholder="Select Phone Code"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.phone_code.$error }">
                              <option value="" disabled style="display:none" selected>Select Phone Code</option>a
                              <option v-for="(country, index) in country_list" :value="country.phoneCode"
                                      v-bind:key="index">{{ country.phoneCode }}
                              </option>
                          </select>
                          <div
                              v-if="submitted && $v.form.phone_code.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.phone_code.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="required" for="phone_number">Phone Number</label>
                    <input
                      id="phone_number"
                      v-model="form.phone_number"
                      name="phone_number"
                      type="text"
                      class="form-control"
                      placeholder="Type phone number"
                      value
                      :class="{ 'is-invalid': submitted && $v.form.phone_number.$error }"
                    />
                    <div
                      v-if="submitted && $v.form.phone_number.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.phone_number.required">This value is required.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="required" for="password">Passowrd</label>
                    <input
                      id="password"
                      v-model="form.password"
                      name="password"
                      type="password"
                      class="form-control"
                      placeholder="Type password here"
                      value
                      :class="{ 'is-invalid': submitted && $v.form.password.$error }"
                    />
                    <div
                      v-if="submitted && $v.form.password.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.password.required">This value is required.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="required" for="password_confirmation">Confirm Password</label>
                    <input
                      id="password_confirmation"
                      v-model="form.password_confirmation"
                      name="password_confirmation"
                      type="password"
                      class="form-control"
                      placeholder="Type password confirmation"
                      value
                      :class="{ 'is-invalid': submitted && $v.form.password_confirmation.$error }"
                    />
                    <div
                      v-if="submitted && $v.form.password_confirmation.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.password_confirmation.required">This value is required.</span>
                    </div>
                  </div>
                </div>
              </div>
              <button class="btn btn-primary" type="submit">Submit</button>
            </b-form>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
<style>
.is-invalid{
    border-color: red!important;
}
</style>

